import axios from "utils/axiosConfig";
import { urlService } from "infra/envs/";

class CandidateService {
    constructor() {
        this.dataBaseURL = urlService.CANDIDATES_API_PATH;
        this.cvBaseURL = urlService.CANDIDATE_CV_PATH;
    }

    getNameById(id, arr) {
        const result = arr.find((item) => item.id === id);
        if (result) {
            return result.name;
        }
    }

    mapCandidateData(candidate) {
        return {
            id: candidate?.id,
            firstName: candidate?.personal_information?.first_name || null,
            lastName: candidate?.personal_information?.last_name || null,
            headline: candidate?.personal_information?.headline || null,
            tags: candidate?.tags || [],
            accessToTalentReady: candidate?.accessToTalentReady || null,
            military: {
                obligation:
                    candidate?.personal_information?.military?.obligation,
                deferment:
                    candidate?.personal_information?.military?.deferment_date,
            },
            email: candidate?.contact_information?.email || null,
            accessToTalent: {
                availability:
                    candidate?.personal_information
                        ?.access_to_talent_availability || false,
                anonymousReport:
                    candidate?.personal_information?.anonymous_report ||
                    undefined,
            },
            phoneCode:
                {
                    id:
                        candidate?.contact_information?.calling_code?.id ||
                        null,
                    name:
                        candidate?.contact_information?.calling_code?.country
                            ?.name &&
                        candidate?.contact_information?.calling_code
                            ?.calling_code
                            ? `${candidate?.contact_information?.calling_code?.country?.name} + ${candidate?.contact_information?.calling_code?.calling_code}`
                            : null,
                    calling_code:
                        candidate?.contact_information?.calling_code
                            ?.calling_code || null,
                } || null,
            phone: candidate?.contact_information?.phone_number || null,
            linkedin: candidate?.contact_information?.linkedin_profile || null,
            collegelink:
                candidate?.contact_information?.collegelink_profile_id || null,
            country: candidate?.personal_information?.city?.country || null,
            city: candidate?.personal_information?.city || null,
            birthdate: candidate?.personal_information?.date_of_birth || null,
            totalYearsOfExperience:
                candidate?.experienceSummary?.totalYearsOfExperience || null,
            summary: {
                currentJobTitle:
                    candidate?.experienceSummary?.currently?.jobTitle || null,
                currentCompanyName:
                    candidate?.experienceSummary?.currently?.company?.name ||
                    null,
                currentCompanyUrl:
                    candidate?.experienceSummary?.currently?.company
                        ?.websiteUrl || null,
                currentRoleExperience:
                    candidate?.experienceSummary?.currently
                        ?.yearsOfExperience || null,
                experienceHighlights:
                    candidate?.experienceSummary?.highlights || null,
                salary: candidate?.job_related_information
                    ?.original_min_monthly_net_salary,
                noticePeriod:
                    candidate?.personal_information?.notice_period || null,
                motivations: candidate?.personality?.motivations || null,

                workModel: candidate?.preferences?.working_models || null,
                contactTypes: candidate?.preferences?.means_of_contact || null,
            },
            personalDetailsAndPreferences: {
                compensationPreferences: {
                    netMontlySalary:
                        candidate?.job_related_information
                            ?.original_min_monthly_net_salary || null,
                    grossAnnualSalary:
                        candidate?.job_related_information
                            ?.original_min_annual_gross_salary || null,
                    compensationPreferences:
                        candidate?.preferences?.compensation_preferences ||
                        null,
                    noticePeriod:
                        candidate?.personal_information?.notice_period || null,
                    availability:
                        candidate?.personal_information?.availability || null,
                    currency: candidate?.preferences?.currency || null,
                },
                personality: {
                    attitude: candidate?.personality?.attitude,
                    motivation: candidate?.personality?.motivations,
                    softSkills: candidate?.personality?.soft_skills || null,
                    otherSkills: candidate?.preferences?.skills || null,
                },
                contactPreferences: {
                    contactFrequency:
                        candidate?.preferences?.contact_frequency || null,
                    meansOfContact:
                        candidate?.preferences?.means_of_contact || null,
                },
                lookingFor: {
                    workModel: candidate?.preferences?.working_models || null,
                    jobType: candidate?.preferences?.job_types || null,
                    industries: candidate?.preferences?.industries || null,
                    jobFunctions: candidate?.preferences?.job_functions || null,
                    occupations: candidate?.preferences?.occupations || null,
                    relocation: candidate?.relocation || null,
                    preferredSkills: candidate?.preferences?.skills,
                    otherSkills: candidate?.personality?.soft_skills || null,
                    mobility: candidate?.preferences?.mobilities || null,
                    companySize: candidate?.preferences?.company_sizes || null,
                    teamSize: candidate?.preferences?.team_size || null,
                    clientFacing: candidate?.preferences?.client_facing || null,
                },
                personalInformation: {
                    gender: candidate?.personal_information?.gender || null,
                    vehicles: candidate?.personal_information?.vehicles || null,
                    languages: candidate?.preferences?.languages || null,
                    militaryObligation:
                        candidate?.personal_information?.military?.obligation ||
                        null,
                    militaryDeferment:
                        candidate?.personal_information?.military
                            ?.deferment_date || null,
                },
            },
            experiences: [],
            cv: {
                hasCv: candidate?.experience?.has_cv || null,
                cvLastUpdateDate: null,
                cvUrl: candidate?.experience?.has_cv
                    ? `${this.cvBaseURL}${candidate?.id}`
                    : null,
            },
            notes: candidate?.notes || null,
            hasNotes: Boolean(candidate?.hasNotes),
            location: candidate?.personal_information?.location,
            parses: candidate?.parses || null,
        };
    }

    mapCandidateAIData(candidate) {
        return {
            candidateInformation: {
                id: candidate?.id,
                firstName: candidate?.firstName || null,
                lastName: candidate?.lastName || null,
                headline: candidate?.headline || null,
                email: candidate?.email || null,
                dateOfBirth: candidate?.dateOfBirth || null,
                location: candidate?.location || null,
                military: {
                    obligation: candidate?.military?.data?.obligation,
                    deferment: candidate?.military?.data?.deferment_date,
                },
                phone: candidate?.phone || null,
                phoneCode:
                    {
                        id: candidate?.phone?.data?.id || null,
                        name:
                            candidate?.phone?.data?.country?.name &&
                            candidate?.phone?.data?.calling_code
                                ? `${candidate?.phone?.data?.country?.name} + ${candidate?.phone?.data?.calling_code}`
                                : null,
                        calling_code:
                            candidate?.phone?.data?.calling_code || null,
                    } || null,
                linkedin: candidate?.linkedin || null,
                linqId: candidate?.linqId || null,
                anonymousReport: candidate?.anonymousRepost || undefined,
            },
            personalDetails: {
                compensation: {
                    currencyId: candidate?.currency|| null,
                    netMonthlySalary:
                        candidate?.netMonthlySalary || null,
                    grossAnnualSalary:
                        candidate?.grossAnnualSalary || null,
                    noticePeriod:
                        candidate?.noticePeriod || null,
                    availability:
                        candidate?.availability || null,
                    compensations: candidate?.compensations || null,
                    
                },
                personality: {
                    attitude: candidate?.attitude || null,
                    motivations: candidate?.motivations || null,
                    softSkills: candidate?.softSkills || null,
                },
                contact: {
                    contactFrequency:
                        candidate?.contactFrequency || null,
                    meansOfContact:
                        candidate?.meansOfContact || null,
                },
                lookingFor: {
                    workingModels: candidate?.workingModels || null,
                    jobTypes: candidate?.jobTypes || null,
                    industries: candidate?.industries || null,
                    jobFunctions: candidate?.jobFunctions || null,
                    occupations: candidate?.occupations || null,
                    relocation: candidate?.relocation || null,
                    hardSkills: candidate?.hardSkills || null,
                    companySizes: candidate?.companySizes || null,
                },
                personalInformation: {
                    gender: candidate?.gender || null,
                    vehicles: candidate?.vehicles || null,
                    languages: candidate?.languages || null,
                }
            },
            experiences: candidate?.experiences || [],
            educations: candidate?.educations || [],
        };
    }

    // Fetch a single candidate by id
    async fetchCandidateById(id) {
        try {
            const response = await axios.get(`${this.dataBaseURL}/${id}`);
            
            return {
                data: this.mapCandidateData(response.data),
                error: null,
                status: response.status,
            };
        } catch (error) {
            return {
                data: null,
                error:
                    error?.response?.data?.message ||
                    "Failed to fetch candidate",
                status: error?.response?.status || 500,
            };
        }
    }
}

const service = new CandidateService();
export default service;
